import './checkout_order_summary.css';
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { useCheckout } from "../../context/CheckoutContext";
import { DeliveryMethod } from "../../Enum/DeliveryMethod";
import { useEffect, useState } from "react";
import { PaymentMethod } from '../../Enum/PaymentMethod';

export const CheckoutOrderSummary = () => {
    //HOOKS
    const { cart } = useCart();
    const {
        tip,
        deliveryPrice,
        selectedDeliveryMethod,
        paymentMethod,
        stripeSettings,
    } = useCheckout();
    const navigate = useNavigate();

    //STATES
    const [total, setTotal] = useState(0);
    const [paymentFee, setPaymentFee] = useState(0);

    //EFFECTS
    useEffect(() => {
        if (cart === null)
        {
            return;
        }

        let totalCalculate = cart.pricing.total;

        totalCalculate += parseInt(tip * 100);
        
        if (selectedDeliveryMethod === DeliveryMethod.DELIVERY)
        {
            totalCalculate += deliveryPrice;
        }

        if (paymentMethod === PaymentMethod.STRIPE && stripeSettings !== null && stripeSettings.charge_fee)
        {
            const percentajeFee = stripeSettings.percentaje_fee / 1000;
            const fixedFee = stripeSettings.fixed_fee;

            const calulatedPercentajeFee = parseInt((totalCalculate * percentajeFee) / 100);
            const totalFee = calulatedPercentajeFee + fixedFee;

            totalCalculate += totalFee;

            setPaymentFee(totalFee);
        }
        else
        {
            setPaymentFee(0);
        }

        setTotal(totalCalculate);
    }, [cart, tip, deliveryPrice, selectedDeliveryMethod, paymentMethod, stripeSettings]);

    return (
        <div className='checkout_order_summary_container'>
            <h2>
                Your Order
            </h2>
            <div className='products_container'>
                {
                    cart !== null && cart.items.map(item => {
                        return (
                            <div className='item' key={'cart_item_' + item.id}>
                                <h2>
                                    {item.product.name} / 
                                </h2>
                                <span>
                                    ${item.subtotal / 100}
                                </span>
                                <p>
                                    Amount: {item.qty}
                                </p>
                            </div>
                        );
                    })
                }
                
            </div>
            <div className='divider'></div>
            <div className='total_container'>
                {
                    cart && (cart.pricing.discount > 0 ) &&
                    (
                        <div className='item'>
                            <span>
                                Discount
                            </span>
                            <span>
                                ${cart && cart.pricing.discount / 100}
                            </span>
                        </div>
                    )
                }
                
                <div className='item'>
                    <span>
                        Subtotal
                    </span>
                    <span>
                        ${cart && cart.pricing.subtotal / 100}
                    </span>
                </div>
                {
                    tip > 0 && (
                        <div className='item'>
                            <span>
                                Tip
                            </span>
                            <span>
                                ${parseInt(tip * 100) / 100}
                            </span>
                        </div>
                    )
                }
                <div className='item'>
                    <span>
                        Tax
                    </span>
                    <span>
                        ${cart && cart.pricing.tax / 100}
                    </span>
                </div>
                {
                    paymentFee > 0 && (
                        <div className='item'>
                            <span>
                                Payment fee
                            </span>
                            <span>
                                ${paymentFee / 100}
                            </span>
                        </div>
                    )
                }
                { deliveryPrice > 0 && selectedDeliveryMethod === DeliveryMethod.DELIVERY && (
                    <div className='item'>
                        <span>
                            Delivery fee
                        </span>
                        <span>
                            ${deliveryPrice / 100}
                        </span>
                    </div>
                )
                }

                <div className='item'>
                    <h2>
                        Total
                    </h2>
                    <h2>
                        ${total / 100}
                    </h2>
                </div>
            </div>
            <div className='actions'>
                <button onClick={()=> navigate('/', {replace:true})}>
                    Go back to menu
                </button>
            </div>
        </div>
    );
}